export class Graduation {

}